import { axiosPrivateInstance } from 'libs/axios';
import { UPDATE_REVIEW_STATUS } from 'utils/serviceUrls';

const updateReviewStatusService = async (id: string, message: string, isProductUpdate: boolean) => {
	const paramData = {
		url: 'string',
		agent: 'string',
		encProductId: id,
		statusId: 3,
		comment: message,
		isProductStatus: isProductUpdate,
	};
	// eslint-disable-next-line no-return-await
	return await axiosPrivateInstance
		.post(UPDATE_REVIEW_STATUS, paramData)
		.then((response: any) => {
			return response;
		})
		.catch(() => {
			return false;
		});
};

export default updateReviewStatusService;
